import { Component } from '@angular/core';
import { PhoneNumberPipe } from '@schoolbelle/common/phone-number';
import { RegularCellComponent } from '@schoolbelle/common/table';
const default_country_dial_code = '82';

@Component({
  selector: '[phone-number-cell]',
  templateUrl: './phone-number-cell.component.html',
  styleUrls: ['./phone-number-cell.component.css'],
  providers:[PhoneNumberPipe],
  // changeDetection:ChangeDetectionStrategy.OnPush,

})
export class PhoneNumberCellComponent extends RegularCellComponent {
  ngOnInit() {
    super.ngOnInit();
    this.subscriptions.add(this.cell.table.onSizeChange.subscribe(()=>this.cdRef.detectChanges()));
  }
}
